export default __webpack_public_path__ + "static/media/trv_2.7a7d5d8d.jpg";